/** Order center pages (pages/order) messages — English */
export default {
  order: {
    common: {
      outbound: 'Outbound',
      return: 'Return',
      roundTrip: 'Round trip',
      oneWay: 'One way',
      multiLeg: 'Multi-city',
      submit: 'Submit',
      next: 'Next',
      detail: 'Details',
      loading: 'Loading...',
      submitting: 'Submitting...',
      saving: 'Saving',
      tip: 'Notice',
      cancel: 'Cancel',
      confirm: 'Confirm',
      copy: 'Copy',
      preview: 'Preview',
      download: 'Download',
      unknown: 'Unknown',
      free: 'Free',
      success: 'Success',
      failed: 'Failed',
      personal: 'Personal',
      company: 'Company',
      enterprise: 'Business',
      pleaseSelect: 'Please select',
      save: 'Save',
      yuan: 'CNY',
      quantityTimes: '×{count}',
    },
    applyRefund: {
      nav: { title: 'Request refund' },
      stepSelectPassengers: '01 Select passengers to refund',
      stepSelectTrips: '02 Select trips to refund',
      stepSelectAddons: '03 Select add-ons to cancel',
      refundBenefits: 'Refund benefits',
      noBenefits: 'No benefits available',
      verifyRefundDetail: 'Review refund breakdown',
      orderAmount: 'Order amount',
      ticketAmount: 'Ticket amount',
      addonProducts: 'Add-ons',
      deductions: 'Deductions',
      ticketDeductions: 'Ticket deductions',
      refundFee: 'Refund fee',
      couponDeduction: 'Coupon deduction',
      addonNotSelected: 'Add-ons (not selected for refund)',
      total: 'Total:',
      refundTotal: 'Refund ￥{amount}',
      estimatedRefund: 'Est. refund',
      beforeCouponRefund: 'Before coupon',
      coupon: 'Coupon',
      unionPointDeduction: 'Union point deduction',
      legFeeLine: '{leg}: -￥{fee}',
      selectPassengerRequired: 'Please select passengers to refund',
      atLeastOnePassenger: 'Keep at least one passenger selected',
      estimatedRefundPoints: 'Est. points refund',
      unionPointCount: '{count} pts',
    },
    confirmRefund: {
      nav: { title: 'Confirm refund' },
      contactInfo: 'Contact info',
      phonePlaceholder: 'Enter mobile number',
      contactTip: 'Important — ensure we can reach you or refund may be affected',
      refundMethod: 'Refund method',
      originalChannel: 'Refund to original payment method',
      refundReason: 'Refund reason',
      estimatedRefund: 'Est. refund',
      detail: 'Details',
      submitRefund: 'Submit refund',
      orderAmount: 'Order amount',
      ticketAmount: 'Ticket amount',
      addonProducts: 'Add-ons',
      deductions: 'Deductions',
      ticketDeductions: 'Ticket deductions',
      refundFee: 'Refund fee',
      couponDeduction: 'Coupon deduction',
      addonNotSelected: 'Add-ons (not selected for refund)',
    },
    refund: {
      nav: { title: 'Request refund' },
      orderRefundable: 'Order refundable',
      cancelPolicy: 'Cancellation policy',
      provideReason: 'Please provide a refund reason',
      feeDisclaimer: 'Final refund amount depends on actual fees charged',
      serviceFee: 'Service fee',
      estimatedRefund: 'Est. refund',
      estimatedRefundPoints: 'Est. points refund',
      unionPointCount: '{count} pts',
      selectReasonRequired: 'Please select a refund reason',
      reason: {
        planChanged: 'Change of plans',
        wrongBooking: 'Wrong / duplicate booking',
        illness: 'Unable to travel due to illness',
        transportDelay: 'Transport delay or cancellation',
        merchantAgreed: 'Agreed refund with merchant',
        hotelPoor: 'Poor hotel environment / facilities',
        hotelNoRoom: 'No room / price increase',
        otherChannel: 'Better price elsewhere',
      },
    },
    refundPlane: {
      nav: {
        selectRefundReason: 'Select refund reason',
        selectChangeReason: 'Select change reason',
      },
      headerTitleRefund: 'Please select your refund reason',
      headerTitleChange: 'Please select your change reason',
      voluntaryRefund: 'Voluntary refund',
      voluntaryChange: 'Voluntary change',
      involuntaryRefund: 'Involuntary refund',
      involuntaryChange: 'Involuntary change',
      airlineFeeRule: 'Fees per airline change & refund policy',
      involuntaryDesc: 'When the airline prevents travel as planned (cancellation, delay, misallocation, ATC, aircraft reassignment, etc.), change/refund follows airline policy — {action}',
      actionRefund: 'refund',
      actionChange: 'change',
      processingTimeShort: 'Processing: 1–3 business days',
      refundTimeShort: 'Refund: 1–3 business days',
      processingTimeLong: 'Processing: 3–7 business days',
      refundTimeLong: 'Refund: 3–7 business days',
      selectRefundReason: 'Select refund reason',
      uploadProof: 'Upload supporting documents',
      uploadDesc: 'Upload proof of cancellation, delay, etc. to speed up your {action} request',
      toast: {
        uploadSuccess: 'Uploaded',
        uploadFailed: 'Upload failed: {msg}',
        uploadFailedRetry: 'Upload failed — please try again',
        uploadProofRequired: 'Please upload supporting documents',
        selectReasonRequired: 'Please select a refund reason',
      },
      reason: {
        planChanged: 'Change of plans',
        wrongBooking: 'Wrong name, date, or flight',
        flightDelay: 'Flight delay, cancellation, or schedule change',
        fullRefund: 'Full refund (special case)',
        other: 'Other',
      },
    },
    refundProgress: {
      nav: { title: 'Refund status' },
      progress: 'Progress',
      refundDetail: 'Refund details',
      actualPaid: 'Amount paid',
      serviceFee: 'Service fee',
      actualRefund: 'Actual refund',
      refundReason: 'Refund reason',
    },
    refundProgressPlane: {
      nav: { title: 'Refund details' },
      travelReminder: 'Travel alert',
      travelReminderColon: 'Travel alert:',
      refundPrefix: 'Refunded ￥',
      expectedRefund: 'Expected refund ￥',
      refundProcessing: 'Refund processing',
      refundSuccess: 'Refund success',
      refundableProducts: 'Products to refund',
      ticketPrice: 'Ticket price',
      actualRefund: 'Actual refund',
      estimatedReviewCompletion: 'Review expected within 7 business days',
    },
    pay: {
      nav: { title: 'Payment' },
      paymentMethods: 'Payment methods',
      otherPaymentChannels: 'Other payment channels',
      changeCard: 'Use another card',
      confirmPay: 'Confirm payment',
      loadingInstallment: 'Loading installment options...',
      noInstallment: 'Pay in full',
      installmentPlan: '￥{amount} × {period} mo.',
      zeroInterest: '0% interest',
      withInterestPerPeriod: 'Incl. interest ¥{amount}/mo.',
      selectBankCard: 'Select bank card',
      addBankCard: 'Add bank card',
      selectBankCardAction: 'Select card',
      noBankCardTip: 'No cards yet — tap above to add one',
      inputVerifyCode: 'Enter verification code',
      resend: 'Resend',
      goPay: 'Pay',
      complete: 'Done',
      inputPlaceholder: 'Enter {field}',
      formName: 'Name',
      formIdCard: 'ID number',
      formBankCard: 'Card number',
      formMobile: 'Mobile on file with bank',
      debitCard: 'Debit card',
      creditCard: 'Credit card',
      paymentMethodTitle: 'Payment method',
      noPaymentMethods: 'No payment methods available',
      paymentPrivilege: 'Payment perks',
      gotIt: 'Got it',
      couponTipTitle: 'Coupon available',
      couponTipText: 'You have a better coupon — save up to ￥{amount}. Use it now?',
      useCoupon: 'Use now',
      discountOff: '-￥{amount}',
      amountTipUnder10: 'Unlock more bank installment options at ¥10 or more',
      amountTipUnder100: 'Unlock more bank installment options at ¥100 or more',
      unionpayPromoTip: 'UnionPay: ¥100 off orders over ¥2000. Stacks with bank discounts below.',
      tagInterestFree: 'Interest-free',
      tagFullPayment: 'Full pay',
      agreementTitle: 'CPCN payment agreement',
      agreementBody: 'I authorize the Interest-free travel Travel mini program to share my mobile number with the credit card installment service and to receive my card binding results for display and selection when paying for ride services in installments.',
      toast: {
        paySuccess: 'Payment successful',
        payCancelled: 'Payment cancelled',
        payFailed: 'Payment failed',
        selectBankFirst: 'Please select a bank card first',
        fillComplete: 'Please complete all fields',
        sendingCode: 'Sending code...',
        payRequestFailed: 'Payment request failed — please try again',
        orderAmountFailed: 'Failed to retrieve the order amount. Please return to the order list and try again.',
        selectPaymentMethod: 'Please select a payment method',
        installmentNotEligible: 'Product type or amount does not qualify for this installment plan',
        switchingBestCoupon: 'Applying best coupon...',
        queryPayResult: 'Checking payment status',
        alipayBrowserOnly: 'Alipay payment requires a mobile browser',
        openAppletFail101: 'Mini program appId is empty. Cannot open.',
        openAppletFail102: 'Target mini program not found. Cannot open.',
        openAppletFailUnknown: 'Failed to open mini program. Please try again.',
      },
    },
    invoice: {
      nav: { title: 'Issue invoice' },
      stepSelectType: '01 Select invoice type',
      stepFillInfo: '02 Invoice details',
      stepDelivery: '03 Delivery info',
      eVoucherTip: 'E-vouchers have the same legal effect as paper vouchers and require no shipping',
      eInvoice: 'E-invoice (general)',
      fillTitleTip: 'General e-invoices require a title; all invoices use the same title by default',
      titleGuideTip: 'Use your name for personal purchases; use company name for reimbursement',
      invoiceTitle: 'Invoice title',
      invoiceNotes: 'Invoice notes',
      notesGuide: 'Confirm with your finance team whether notes are required',
      notesLimit: '(Notes appear on general e-invoices only; insurance invoices excluded)',
      email: 'Email',
      emailPlaceholder: 'Email for receiving e-voucher',
      invoiceAmount: 'Invoice amount',
      invoiceDetail: 'Invoice breakdown',
      editTitle: 'Edit invoice title',
      addTitle: 'Add invoice title',
      addPersonalTitle: 'Add personal invoice title',
      addEnterpriseTitle: 'Add business invoice title',
      addPersonalInfo: 'Add personal info',
      selectPassengers: 'Select passengers',
      selectTitle: 'Select invoice title',
      selectPersonalInfo: 'Select personal info',
      selectEnterpriseTitle: 'Select business invoice title',
      idNumber: 'ID: {number}',
      idNumberLabel: 'ID number',
      taxNumber: 'Tax ID: {number}',
      personalTitle: 'Personal title',
      enterpriseTitle: 'Business title',
      taxpayerId: 'Taxpayer ID',
      personalTitlePlaceholder: 'Enter personal title',
      idNumberPlaceholder: 'Enter ID number',
      enterpriseTitlePlaceholder: 'Enter business title',
      taxpayerIdPlaceholder: 'Enter taxpayer ID',
      verifyDetail: 'Review invoice breakdown',
      couponNoInvoice: 'Coupon payments cannot be invoiced',
      sendTimeTip: 'E-invoices are sent after order completion, usually the same day.',
      invoiceInfo: 'Invoice info',
      titleWillShow: 'All e-invoices will show this title',
      notesWillShow: 'Notes will appear on the e-invoice',
      deliveryInfo: 'Delivery info',
      orderNoWithTime: '{time} | Order No.: {orderNo}',
      hotelName: 'Hotel: {name}',
      checkIn: 'Check-in: {date}',
      checkOut: 'Check-out: {date}',
      productName: 'Product: {name}',
      travelDate: 'Travel date: {date}',
      carTrip: 'From {from} to {to}',
      trainTravelDate: 'Travel date: {date}',
      trainSeat: 'Train / seat: {info}',
      passengerCount: 'Passengers: {count}',
      trainTicketAmount: 'Train ticket amount',
      amount: 'Amount',
      insuranceAmount: 'Insurance amount',
      ticketPriceDetail: 'Fare: ￥{ticketPrice} + ￥{servicePrice} (service) = ￥{totalPrice}',
      trainPassengers: 'Passengers: {names}',
      backToEdit: 'Back to edit',
      train12306Guide: 'Select invoice type, then passengers and {target}',
      train12306TargetPersonal: 'personal info and business title',
      train12306TargetTitle: 'invoice title',
      train12306MultiTipPersonal: 'Multiple personal entries allowed; one business title only',
      train12306MultiTipTitle: 'Multiple personal titles allowed',
      sendAfterTicket: 'Sent after all tickets are issued',
      sendAfterCheckout: 'Sent after checkout',
      sendAfterComplete: 'Sent after order completion',
      productType: {
        plane: 'Flight',
        hotel: 'Hotel',
        tourism: 'Tour',
        train: 'Train',
        intlPlane: 'Intl. flight',
        intlHotel: 'Intl. hotel',
        car: 'Ride',
      },
      noteTab: {
        orderNo: 'Order No.',
        tripInfo: 'Trip info',
        flightNo: 'Flight No.',
        passengers: 'Passengers',
        hotelDates: 'Hotel & dates',
        travelDate: 'Travel date',
        destination: 'Destination',
        scenicName: 'Attraction',
        travelers: 'Travelers',
        trip: 'Trip',
        date: 'Date',
        trainInfo: 'Train info',
        trainPassengers: 'Passengers',
      },
      notes: {
        orderNo: 'Order No.: {orderNo}',
        roundTripRoute: 'Round trip {from} to {to}',
        oneWayRoute: 'One way {from} to {to}',
        roundTripFlight: 'Round trip Out: {outbound} Back: {inbound}',
        oneWayFlight: 'One way {flightNum}',
        passengers: 'Passengers: {names}',
        multiRoute: 'Multi-city: {from} to {to} and more',
        route: 'Route: {from} to {to}',
        tripInfo: 'Trip info',
        intlFlights: 'Intl. flights: {flightNums}',
        flightNo: 'Flight No.',
        passenger: 'Passengers',
        hotelStay: '{hotelName} Check-in: {checkIn} Check-out: {checkOut}',
        travelDate: 'Travel date: {date}',
        destination: 'Destination: {name}',
        scenicName: 'Attraction: {name}',
        travelers: 'Travelers: {names}',
        carTrip: 'From {from} to {to}',
        date: 'Date: {date}',
        trainTrip: 'Trip: {from} to {to}',
        trainNumber: 'Train: {info}',
        trainPassengers: 'Passengers: {names}',
        trainPassenger: 'Passengers',
      },
      toast: {
        selectPassenger: 'Please select passengers',
        selectTitle: 'Please select an invoice title',
        selectPersonalInfo: 'Please select personal info',
        selectEnterpriseTitle: 'Please select a business invoice title',
        fillEmail: 'Please enter email',
        selectPassengerTitle: 'Please select {label}',
        submitFailed: 'Submit failed — please try again',
        titleExceedPassengers: 'Title count cannot exceed passenger count',
        titleNotInPassengers: 'Title not linked to selected passengers',
        personalIdRequired: 'Personal title requires ID number',
        personalInfoExceed: 'Personal info count cannot exceed passenger count',
        personalInfoNotInPassengers: 'Personal info not linked to selected passengers',
        personalInfoIdRequired: 'Personal info requires ID number',
        deleteSuccess: 'Deleted',
        passengerListFailed: 'Failed to load passengers',
        fillTitle: 'Please enter title',
        fillIdNumber: 'Please enter ID number',
        fillTaxpayerId: 'Please enter taxpayer ID',
        saveSuccess: 'Saved',
        deleteConfirm: 'Delete this title?',
        selectCountMismatch: 'Please select {required} {label}(s); {selected} selected',
        titleShort: 'title(s)',
        personalInfoShort: 'personal info',
      },
    },
    invoiceDetail: {
      nav: { title: 'Invoice details' },
      orderNo: 'Order No.: {orderNo}',
      travelOn: 'Travel {date} {time}',
      passengers: 'Passengers: {names}',
      hotelName: 'Hotel: {name}',
      checkIn: 'Check-in: {date}',
      checkOut: 'Check-out: {date}',
      guest: 'Guest: {name}',
      productName: 'Product: {name}',
      travelDate: 'Travel date: {date}',
      travelers: 'Travelers: {names}',
      carTrip: 'From {from} to {to}',
      insuranceType: 'Insurance: {name}',
      insured: 'Insured: {names}',
      transferCount: '{count} transfer(s)',
      passenger: 'Passenger: {names}',
      trainInfo: 'Train: {info} {date} {time}',
      segmentTag: 'Leg {index}',
      invoiceTitle: 'Invoice title: {title}',
      eInvoice: 'E-invoice (general)',
      amount: 'Amount',
      amountWithCount: '￥{amount} × 1',
      otherInfo: 'Other info',
      applyTime: 'Applied:',
      email: 'Email:',
      emailAddress: '{email} (delivery address)',
      tip: 'Note:',
      tipSevenDays: 'Invoice will be emailed within about 7 business days',
      downloadLink: 'Invoice download link',
      downloadLinkHint: 'Copy and open in browser to download',
      previewDownload: 'Preview & download',
      previewDownloadHint: 'Tap to preview, download, or copy link',
      imageIndex: ' (No. {index})',
      toast: {
        fetchFailed: 'Failed to load invoice details',
        invalidDownloadLink: 'Invalid download link',
        saveSuccess: 'Saved',
        savePermission: 'Photo permission required — enable in Settings',
        parseFailed: 'Failed to parse image',
        invalidPreviewLink: 'Invalid preview link',
        previewFailed: 'Preview failed — please try again',
        previewError: 'Preview error — please try again',
        orderDetailFailed: 'Failed to load order details',
      },
    },
    invoiceSuccess: {
      nav: { title: 'Submitted' },
      title: 'Submitted',
      subtitle: 'Your invoice request has been submitted',
      invoiceInfo: 'Invoice info',
      eInvoice: 'E-invoice',
      issueAfterComplete: 'Issued after order completion',
      reimbursementAmount: 'Reimbursement amount',
      applyTime: 'Applied at',
      backHome: 'Home',
      invoiceDetail: 'Invoice details',
      selectInvoice: 'Select invoice',
      unnamedInvoice: 'Untitled invoice',
      amount: 'Amount: ￥{amount}',
      invoiceTime: 'Issued: {time}',
      toast: {
        noInvoiceInfo: 'No invoice information',
        queryFailed: 'Query failed',
      },
    },
  },
}
